export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE () {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}
export function scorePassword (pass) {
  let score = 0
  if (!pass) {
    return score
  }
  // award every unique letter until 5 repetitions
  const letters = {}
  for (let i = 0; i < pass.length; i++) {
      letters[pass[i]] = (letters[pass[i]] || 0) + 1
      score += 5.0 / letters[pass[i]]
  }

  // bonus points for mixing it up
  const variations = {
      digits: /\d/.test(pass),
      lower: /[a-z]/.test(pass),
      upper: /[A-Z]/.test(pass),
      nonWords: /\W/.test(pass)
  }

  let variationCount = 0
  for (var check in variations) {
      variationCount += (variations[check] === true) ? 1 : 0
  }
  score += (variationCount - 1) * 10

  return parseInt(score)
}

/**​
 * 生成视频缩略图
 * @param {File} file - 视频文件对象
 * @returns {Promise<string>} 返回Base64缩略图或空字符串
 */
export async function extractVideoThumbnail(file) {
  return new Promise((resolve) => {
    // ------------------ 初始化视频元素 ------------------
    const video = document.createElement('video');
    
    /**​
     * 硬件加速兼容性设置
     * 1. 禁用远程播放：避免出现Chromecast/AirPlay按钮
     * 2. 双保险设置iOS内联播放属性：兼容不同浏览器实现
     * 3. 匿名跨域：解决部分安卓机型解码问题
     */
    video.disableRemotePlayback = true; // 标准API禁止投屏
    video.setAttribute('playsinline', ''); // HTML属性设置
    video.setAttribute('webkit-playsinline', ''); // 旧版iOS支持
    video.setAttribute('x-webkit-airplay', 'deny'); // 明确拒绝AirPlay
    video.setAttribute('crossorigin', 'anonymous'); // 安卓解码优化

    // ------------------ 初始化画布 ------------------
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { willReadFrequently: true }); // 优化频繁读取操作

    // 调试追踪标识
    const sessionId = Math.random().toString(36).slice(2, 7);
    console.log(`[${sessionId}] 初始化处理器 | 文件: ${file.name}`);

    // ------------------ 状态控制 ------------------
    let retryCount = 0;
    const maxRetries = 5; // 增加重试次数应对复杂场景
    let lastResult = null;
    let duration = 0;

    // ------------------ 核心算法 ------------------
    /**​
     * 动态时间点生成策略
     * 设计原则：
     * - 前3秒是重点检测区域（避开可能的开头黑屏）
     * - 长视频增加中间和结尾采样
     */
    const generateTimePoints = () => {
      const points = [];
      if (duration <= 0.3) { // 抖音类超短视频
        points.push(0, duration * 0.5, duration);
      } else if (duration <= 2) { // 短视频
        points.push(0.1, duration * 0.7, duration - 0.1);
      } else if (duration <= 10) { // 中等视频
        points.push(0.1, 0.5, 1);
      } else { // 长视频
        points.push(0.1, 0.5, 1);
      }
      return points.map(t => Math.min(t, duration - 0.001)); // 防止溢出
    };

    /**​
     * 增强型黑屏检测算法
     * 检测策略：
     * 1. 四角+中心共5点采样
     * 2. 避开边缘1像素（解决编码噪点）
     * 3. 允许5%的误差范围
     */
    const isBlackFrame = () => {
      try {
        const samplePoints = [
          [1, 1], // 左上
          [canvas.width - 2, 1], // 右上
          [1, canvas.height - 2], // 左下
          [canvas.width - 2, canvas.height - 2], // 右下
          [canvas.width >> 1, canvas.height >> 1] // 中心
        ];

        return samplePoints.every(([x, y]) => {
          // 边界保护（处理异常尺寸）
          if (x >= canvas.width || y >= canvas.height) return true;
          
          const pixel = ctx.getImageData(x, y, 1, 1).data;
          console.log(`[${sessionId}] 像素检测 (${x},${y}): ${pixel.slice(0, 3)}`);
          
          // 放宽阈值到30（兼容低光照视频）
          return pixel[0] < 30 && pixel[1] < 30 && pixel[2] < 30;
        });
      } catch (e) {
        console.error(`[${sessionId}] 黑屏检测失败:`, e);
        return false; // 失败时假定非黑屏
      }
    };

    /**​
     * 增强型帧捕获
     * 优化点：
     * 1. 双重缓冲机制（readyState + seeked）
     * 2. 异常尺寸检测
     * 3. 渲染延迟补偿
     */
    const captureFrame = async (seekTime) => {
      console.log(`[${sessionId}] 捕获尝试 #${retryCount + 1} | 目标: ${seekTime}s`);
      
      try {
        // 精确时间定位（修复iOS精度问题）
        video.currentTime = Math.max(0, Math.min(seekTime, duration - 0.001));
        
        // ------------------ 双重缓冲机制 ------------------
        await new Promise((resolve) => {
          const handleReady = () => {
            console.log(`[${sessionId}] 缓冲完成 | 实际时间: ${video.currentTime.toFixed(3)}s`);
            setTimeout(resolve, 200); // 关键：等待渲染管线完成
          };

          if (video.readyState >= 4) { // HAVE_ENOUGH_DATA
            console.log(`[${sessionId}] 立即就绪 | readyState: ${video.readyState}`);
            handleReady();
          } else {
            video.addEventListener('seeked', handleReady, { once: true });
          }
        });

        // ------------------ 异常尺寸处理 ------------------
        if (video.videoWidth * video.videoHeight === 0) {
          console.error(`[${sessionId}] 解码失败 | 尺寸: ${video.videoWidth}x${video.videoHeight}`);
          return false;
        }

        // ------------------ 自适应画布 ------------------
        const MAX_SIZE = 1600; // 平衡清晰度和性能
        const scale = Math.min(
          MAX_SIZE / video.videoWidth,
          MAX_SIZE / video.videoHeight
        );
        canvas.width = Math.floor(video.videoWidth * scale);
        canvas.height = Math.floor(video.videoHeight * scale);
        console.log(`[${sessionId}] 画布设置 | 缩放: ${scale.toFixed(2)} 尺寸: ${canvas.width}x${canvas.height}`);

        // ------------------ 高质量渲染 ------------------
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        
        // 结果缓存（即使可能失败）
        lastResult = canvas.toDataURL('image/jpeg', 0.85); // 85%质量平衡
        const isBlack = isBlackFrame();
        console.log(`[${sessionId}] 捕获结果 | 黑屏: ${isBlack}`);
        
        return !isBlack;
      } catch (error) {
        console.error(`[${sessionId}] 捕获异常:`, error);
        return false;
      }
    };

    // ------------------ 主控制流程 ------------------
    const attemptCapture = async () => {
      const timePoints = generateTimePoints();
      console.log(`[${sessionId}] 时间点策略: [${timePoints.map(t => t.toFixed(2))}s]`);

      while (retryCount < maxRetries) {
        const success = await captureFrame(timePoints[retryCount]);
        if (success) break;
        retryCount++;
      }
      return lastResult;
    };

    // ------------------ 事件处理器 ------------------
    video.addEventListener('loadedmetadata', async () => {
      try {
        duration = Math.max(video.duration || 0, 0.01);
        console.log(`[${sessionId}] 元数据加载 | 时长: ${duration.toFixed(2)}s | 编码: ${video.videoWidth}x${video.videoHeight}`);
        
        const result = await attemptCapture();
        cleanupResources();
        resolve(result || '');
      } catch (e) {
        console.error(`[${sessionId}] 主流程异常:`, e);
        resolve('');
      }
    });

    video.addEventListener('error', () => {
      console.error(`[${sessionId}] 视频错误 | 代码: ${video.error?.code}`);
      cleanupResources();
      resolve('');
    });

    // ------------------ 资源清理 ------------------
    const cleanupResources = () => {
      URL.revokeObjectURL(video.src); // 释放内存
      video.pause(); // 停止解码
      video.removeAttribute('src'); // 断开连接
      canvas.width = 0; // 释放显存
      console.log(`[${sessionId}] 资源已释放`);
    };

    // ------------------ 启动处理 ------------------
    video.muted = true; // 绕过自动播放限制
    video.preload = 'auto'; // 预加载优化
    video.src = URL.createObjectURL(file);
    video.load(); // 显式触发加载
  });
}

//将base64转换为blob
export function dataURLtoBlob(dataurl) {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], `1.${suffix}`, {
    type: mime,
  })
}

import Md5Worker from './workers/md5.worker.js';

export async function calculateMD5(file) {
  const md5Worker = new Md5Worker();
  return new Promise((resolve, reject) => {
    const chunkSize = 5 * 1024 * 1024; // 10MB分片
    let offset = 0;
    md5Worker.postMessage({ action: 'init' });

    md5Worker.onmessage = (e) => {
      console.log(e.data.md5,"e.data.md5");
      if (e.data.error) reject(e.data.error);
      if (e.data.md5) resolve(e.data.md5);
    };

    const readNextChunk = () => {
      const chunk = file.slice(offset, offset + chunkSize);
      const reader = new FileReader();
      reader.onload = (e) => {
        md5Worker.postMessage({
          action: 'append',
          chunk: e.target.result
        }, [e.target.result]);
        offset += chunkSize;
        if (offset < file.size) {
          readNextChunk();
        } else {
          md5Worker.postMessage({ action: 'finalize' });
        }
      };
      reader.readAsArrayBuffer(chunk);
    };

    readNextChunk();
  });
}

// 上传文件
export async function uploadFileToOss(client, file, name, options) {
  let opts = {}
  if (options === undefined) {
    opts = {
      headers: {
        'x-oss-object-acl': 'public-read', // 设置文件的访问权限为公共读，这样浏览器才能下载访问
        'Content-Disposition': 'inline',
        'content-type': file.type.toLowerCase(), //
      },
    }
  }
  try {
    const result = await client.multipartUpload(
      name,
      file,
      opts,
    )
    return result // 返回文件信息
  } catch (error) {
    throw new Error(`文件上传失败: ${error.message}`)
  }
}

// 旋转图片
export const getRotateUrl = (url) =>{
  const urlString = url.split("?")[0]
  const isALiYun = url.includes('aliyuncs.com')
  console.log(isALiYun,"阿里云")
  let rotateUrl = "";
  // 阿里云
  if(isALiYun){
    const rotate = url.split('rotate,')
    // 旋转前,没有角度或者能被360整除视为360度
    const rotatePrev = rotate[1] ? Number(rotate[1])%360 === 0 ? 360 : Number(rotate[1]) : 360
    const rotateValue = Number(rotatePrev) - 90
    rotateUrl = urlString + `?x-oss-process=image/rotate,${ rotateValue }`
  // 腾讯云
  }else{
    const rotate = url.split('rotate/')
    // 旋转前,没有角度或者能被360整除视为360度
    const rotatePrev = rotate[1] ? Number(rotate[1])%360 === 0 ? 360 : Number(rotate[1]) : 360
    const rotateValue = Number(rotatePrev) - 90
    rotateUrl = urlString + `?imageMogr2/rotate/${ rotateValue }`
  }
  console.log(rotateUrl,"rotateUrl");
  return rotateUrl
}

export const getUnicodeNumber = (index) => {
  // Unicode范围：
  // 带圈数字1-20: ①-⑳ (0x2460-0x2473)
  // 带圈数字21-35: ㉑-㉟ (0x3251-0x325F)
  // 带圈数字36-50: ㊱-㊿ (0x32B1-0x32BF)
  if (index >= 0 && index <= 19) {
    // ①-⑳: 0x2460 + index
    return String.fromCodePoint(0x2460 + index);
  } else if (index >= 20 && index <= 34) {
    // ㉑-㉟: 0x3251 + (index - 20)
    return String.fromCodePoint(0x3251 + (index - 20));
  } else if (index >= 35 && index <= 49) {
    // ㊱-㊿: 0x32B1 + (index - 35)
    return String.fromCodePoint(0x32B1 + (index - 35));
  } else {
    return `${index + 1}.`;
  }
}